import React, { useState } from "react";
import * as _ from "lodash";
import { ITool } from "../../interface/ITool";
import { ISignout } from "../../interface/ISignout";
import { StepperForm } from "./Form";
import { StepperHeader } from "./Stepper";
import { ToolHeader } from "../../../../../components/Toolkit/Tool/Type/Layout";
import { Container } from "@material-ui/core";

type props = {
  tool: ITool;
  onChange: any;
  onSubmit: any;
  onValidateForms: any;
  handleNewForm: any;
  backBtnTitle: string;
  handleBackButton: any;
  signoutConfig: ISignout;
  loading: boolean;
  ishavingParent:any;
};



export const MultiStepperForm = (props: props): JSX.Element => {
  const {
    tool,
    onChange,
    onSubmit,
    onValidateForms,
    handleNewForm,
    backBtnTitle,
    handleBackButton,
    loading,
    signoutConfig,
    ishavingParent
  } = props;

  const [activeStep, setActiveStep] = useState(0);

  const handleNextBack = (step: number): void => {
    const count = _.takeWhile(_.slice(tool.forms,(activeStep+step)),{isVisible: false}).length;
    if(_.gt(count,0) && !_.lt(step,0)){
      setActiveStep((prevActiveStep) => (prevActiveStep + step + count));
    }else if(_.lt(step,0)){
      reverseStep(step);
    }else{
      setActiveStep((prevActiveStep) => prevActiveStep + step);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const reverseStep = (step: number): void => {
    let count = 0;
    let isVisibleTrue = false;
    const from_data = tool.forms.slice(0, (activeStep + step + 1));
    _.forEachRight(from_data, (form) => { //reverse loop
      if (_.isEqual(count, 0) && form.isVisible) {
        isVisibleTrue = true;
      }
      if (form.isVisible) {
        return false;
      }
      count++;
    });
    isVisibleTrue ? setActiveStep((prevActiveStep) => prevActiveStep + step) : setActiveStep(count - 1);
  };

  const goToStep = (step: number): void => {
    setActiveStep(() => step);
  };

  const handleReset = (): void => {
    setActiveStep(0);
  };
  const ToolInfo = {
    data: { ...tool },
  };

  return (
    <div>
      <ToolHeader
        backBtnTitle={backBtnTitle}
        handleBackButton={handleBackButton}
        signoutConfig={signoutConfig}
        {...ToolInfo}
        stepper={<StepperHeader forms={tool.forms} activeStep={activeStep} />}
      />
      <Container maxWidth="lg">
        <StepperForm
          tool={tool}
          onChange={onChange}
          goToStep={goToStep}
          onValidateForms={onValidateForms}
          onSubmit={onSubmit}
          handleNewForm={handleNewForm}
          handleNextBack={handleNextBack}
          handleReset={handleReset}
          activeStep={activeStep}
          handleBackButton={handleBackButton}
          loading={loading}
          ishavingParent={ishavingParent}
        />
      </Container>
    </div>
  );
};
